<template >
    <div style="">
        <div  >

            <div style="top:-156px;position:fixed;">
                <div style="z-index:0;position:relative;width:100%;height:100%;margin-left:0;background: rgb(154,255,186);background: linear-gradient(40deg, rgba(164, 65, 248, 0.72) 0%, rgb(47, 218, 158) 100%);">
                    <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="pointer-events: none;z-index: -1;">
                        <source :src='require("../assets/white_flare.webm")'>

                    </video>
                    <video  loop="" muted="" autoplay="" style="opacity: 0.2;pointer-events: none;z-index: -1;height:calc(100vh + 200px);">">
                        <source :src="require('../assets/sh_reel.mp4')">
                    </video>


                </div>




            </div>
            <v-row
                    align="center"
                    justify="center"

                    class="mx-auto"
                    style="height:80vh;top:-40px;z-index: 5;position: absolute;width:100%;"

            >


                <v-col align="center"  style="max-width:600px;background: rgba(129, 134, 169, 0.34); border-radius: 20px;padding:20px;" >
                    <h3 class="font-weight-light" style="margin-top:0px;">Välkommen till</h3>

                    <v-img
                            contain
                            height="250"
                            :src="require('../assets/sh_logo.png')"
                    >


                    </v-img>


                    <span>
                    <v-btn  block class="mx-auto my-4" x-large href="https://dashboard.twitch.tv/extensions/p18s2dpx5vwtnmwa7260tse7zxo3ay-0.0.1" target="_blank" dark style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" color="teal">Installera</v-btn>

                </span>


                </v-col>

            </v-row>










            <svg  :style="{'margin-top':$vuetify.breakpoint.mdAndUp? '500px':'650px'}" style="position:relative;z-index: 1;margin-bottom:0;pointer-events: none;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#e7e7e7" fill-opacity="1" d="M0,320L48,288C96,256,192,192,288,154.7C384,117,480,107,576,112C672,117,768,139,864,128C960,117,1056,75,1152,85.3C1248,96,1344,160,1392,192L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>

            </svg>


            <v-row align="center" justify="center" class="mx-auto" style="background:#e7e7e7;position: relative;margin-top: -8px;z-index: 1;padding-bottom:80px;">
                <v-col :style="{'margin-top': $vuetify.breakpoint.mdAndUp?'-150px':'-50px'}"  class="mb-12" cols="12">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <v-card-title>Spela i streamen</v-card-title>
                        <v-card-text>
                            Stream Hotel är ett 3D-multiplayer-spel som spelas i en <b>overlay</b> ovanför din stream. <br>

                            Dina tittare kan hålla sig varma vid elden, eller få upp värmen genom att dansa på borden. Bygg en starkare community där trogna tittare belönas med guld, och nya tittare får en större anledning att hänga kvar!
                        </v-card-text>

                    </v-card>
                </v-col>

                <v-col class="pa-0" cols="12" justify="center" >
                    <v-img
                            height="800"
                            contain
                            :src="require('../assets/overlay.png')">

                    </v-img>

                </v-col>


            </v-row>
            <v-row style="margin-top:40px;" align="center" justify="center">
                <v-col>
                    <v-img
                            height="600"
                            contain
                            :src="require('../assets/city.png')">

                    </v-img>

                </v-col>
            </v-row>
            <v-row style="background:#e7e7e7;position: relative;margin-top: 40px;z-index: 1;padding-bottom:80px;">
                <v-col  cols="12">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <v-card-title>Utforska staden</v-card-title>
                        <v-card-text>
                            Utforska staden i en av 20+ bilar, besök en av stadens butiker och spendera allt på prylar, eller återinvestera ditt guld i gear till din dator för att tjäna ännu mer!
                        </v-card-text>

                    </v-card>
                </v-col>
                <v-col>
                    <v-img
                            height="400"
                            contain
                            :src="require('../assets/cars.png')">

                    </v-img>

                </v-col>





            </v-row>
            <v-row style="margin-top:40px;" align="center" justify="center">
                <v-col>
                    <v-img
                            height="600"
                            contain
                            :src="require('../assets/trade.png')">

                    </v-img>

                </v-col>
            </v-row>

            <v-row style="background:#e7e7e7;position: relative;margin-top: 40px;z-index: 1;padding-bottom:10px;">
                <v-col cols="12">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <v-card-title>Samla och byt</v-card-title>
                        <v-card-text>
                            Samla och byt över 300 föremål. Klä din karaktär i streamerns merch, eller varför inte slänga på dig en hatt? Kanske en pirat-hatt?
                        </v-card-text>

                    </v-card>
                </v-col>

            </v-row>
            <v-row style="margin-top:40px;" align="center" justify="center">
                <v-col>
                    <v-img
                            height="600"
                            contain
                            :src="require('../assets/chests.png')">

                    </v-img>

                </v-col>
            </v-row>

            <v-row style="background:#e7e7e7;position: relative;margin-top: 40px;z-index: 1;">
                <v-col cols="12">
                    <v-card style="background:transparent;max-width:600px;" flat class="mx-auto">
                        <v-card-title>Stötta streamen</v-card-title>
                        <v-card-text>
                            Stötta streamen och köp en av flera chests, med chans till att unboxa ovanliga lojalitetsföremål.
                        </v-card-text>

                    </v-card>
                </v-col>

            </v-row>
            <v-btn  block class="mx-auto my-4" x-large href="https://dashboard.twitch.tv/extensions/p18s2dpx5vwtnmwa7260tse7zxo3ay-0.0.1" target="_blank" dark style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" color="teal">Installera</v-btn>








        </div>






    </div>
</template>

<script>



    export default {
        name: 'Home',
        components: {


        },
        data(){
            return{
                collection_cards:[
                    {"SID":1,"CID":169,"USER_NAME":"guthentwitch","DATE_REG":"2020-01-05","TYPE":0,"FLOAT_X":0.9155773827606586,"FLOAT_Y":0.3876478327668196,"COID":1,"cCMID":10,"NAME":"Roleplaying","DEFAULT_IMAGE":"bg.jpg","STID":79,"DESC":"Det är faktiskt bara ett spel…","TEXT":null,"CRID":34,"RANK_VALUE":0,"SPECULAR":"0x111111","SHININESS":1,"DECORATOR_IMAGE":"0.png","BG_IMAGE":null},
                    {"SID":1803,"CID":46,"USER_NAME":"guthentwitch","DATE_REG":"2019-12-20","TYPE":0,"FLOAT_X":0.45790841301177676,"FLOAT_Y":0.85322,"COID":2,"cCMID":5,"NAME":"Space","DEFAULT_IMAGE":"bg.jpg","STID":79,"DESC":"Grund kontroll till Major Tomas","TEXT":null,"CRID":14,"RANK_VALUE":1,"SPECULAR":"0x111111","SHININESS":0.5,"DECORATOR_IMAGE":"1.png","BG_IMAGE":null},
                    {"SID":1803,"CID":199,"USER_NAME":"guthentwitch","DATE_REG":"2020-01-27","TYPE":0,"FLOAT_X":0.5109168557280801,"FLOAT_Y":0.024555018113104454,"COID":2,"cCMID":5,"NAME":"Space","DEFAULT_IMAGE":"bg.jpg","STID":79,"DESC":"Grund kontroll till Major Tomas","TEXT":null,"CRID":15,"RANK_VALUE":2,"SPECULAR":"0x111111","SHININESS":0.5,"DECORATOR_IMAGE":"2.png","BG_IMAGE":null},
                    {"SID":1803,"CID":84,"USER_NAME":"guthentwitch","DATE_REG":"2019-12-26","TYPE":0,"FLOAT_X":0.06438614886055971,"FLOAT_Y":0.013207111082544909,"COID":1,"cCMID":9,"NAME":"Scripted Content","DEFAULT_IMAGE":"bg.jpg","STID":79,"DESC":"Någon som vet namnet på regissören?","TEXT":null,"CRID":33,"RANK_VALUE":3,"SPECULAR":"orange","SHININESS":1,"DECORATOR_IMAGE":"3.png","BG_IMAGE":null}
                ],
                action_cards:[
                    {"TYPE":1,"DATE_REG":"2020-08-07","ACID":22,"SID":1,"ACMID":14,"USED":0,"DATE_USED":null,"STID":1,"RANK":0,"TEXT":`  Detta kort tvingar Guthen att \n   under en minut avsluta varje \n   mening med 'Okej Mamma!'`,"NAME":"guthenGiggle","DELETED":0,"VIDEO":{"url":null,"video_id":null,"volume":100,"opacity":100,"start":0,"end":10},"USER_NAME":"guthentwitch"},
                    {"TYPE":1,"DATE_REG":"2020-06-26","ACID":403,"SID":1,"ACMID":10,"USED":0,"DATE_USED":null,"STID":1,"RANK":1,"TEXT":"\n                 LOOOOOL","NAME":"guthenFAIL","DELETED":0,"VIDEO":{"opacity":100,"volume":100,"video_id":"Fkk9DI-8el4","start":"26","end":43,"url":"https://www.youtube.com/watch?v=Fkk9DI-8el4"},"USER_NAME":"guthentwitch"},
                    {"TYPE":1,"DATE_REG":"2020-06-26","ACID":403,"SID":1,"ACMID":10,"USED":0,"DATE_USED":null,"STID":1,"RANK":2,"TEXT":"              Hey Mister DJ\n             Put a record on\n  I wanna dance with my baby","NAME":"guthenDJ","DELETED":0,"VIDEO":{"opacity":0,"volume":100,"video_id":"FFA","start":"10","end":10,"url":"https://www.youtube.com/watch?v=FFA"},"USER_NAME":"guthentwitch"},
                    {"TYPE":1,"DATE_REG":"2020-06-26","ACID":403,"SID":1,"ACMID":10,"USED":0,"DATE_USED":null,"STID":1,"RANK":3,"TEXT":"If you get it on tape, you could get it in on stream! \n\n          Goodnight folks","NAME":"Fredagsmys","DELETED":0,"VIDEO":{"opacity":100,"volume":100,"video_id":"FFA","start":"10","end":10,"url":"https://www.youtube.com/watch?v=FFA"},"USER_NAME":"guthentwitch"}

                ],
                collection_card_index:0,
                collection_show:false,
                selected_collection_card:null,
                action_card_index:0,
                action_show:false,
                selected_action_card:null,
                selected_action_card_play:null,
                actionShow:false,
                videoId: '',
                playerVars:{
                    autoplay: 0,
                    controls: 0,
                    start:16,
                    fs:1,
                    iv_load_policy:3,
                    modestbranding:1,

                },
                opacity:1,
                show_video:false
            }

        },
        computed:{


        },
        methods:{
            ready (event) {
                this.player = event.target;
                this.show_video=false;
            },
            playAction:function(){
                this.selected_action_card_play=JSON.parse(JSON.stringify(this.selected_action_card));
                this.actionShow=true;
                this.selected_action_card_play.USER_NAME="Hihat-gäst";
                if(this.selected_action_card.VIDEO.video_id!==null){
                    this.handle_card_video(this.selected_action_card.VIDEO);
                }


            },
            actionFinished:function(){
                this.actionShow=false;
            },

            letsgo:function(){
                this.$store.state.APP.SHOW_LOGIN=true;
            },
            letsgome:function(){
                this.$router.push({ path: `/inventory/${this.$store.state.STREAMER.SID}` })

            },
            goLeft:function(){
                this.collection_card_index-=1;
                if(this.collection_card_index<0){
                    this.collection_card_index=3
                }
                this.selected_collection_card=this.collection_cards[this.collection_card_index]

            },
            goRight:function(){
                this.collection_card_index+=1;
                if(this.collection_card_index>3){
                    this.collection_card_index=0
                }
                this.selected_collection_card=this.collection_cards[this.collection_card_index]



            },
            handle_card_video:function(video_data){
                console.log(video_data);
                if(video_data.video_id==="FFA"){
                    this.player.pauseVideo();
                    this.show_video=true;
                    let duration=video_data.start;
                    this.player.setVolume(video_data.volume);
                    this.opacity=video_data.opacity/100;
                    this.player.loadVideoById({videoId:this.$refs.actioncardHolder.video_id,
                        startSeconds:this.$refs.actioncardHolder.video_start,
                        endSeconds:this.$refs.actioncardHolder.video_start+duration});
                    let self=this;
                    setTimeout(function(){
                        self.player.pauseVideo();
                        self.show_video=false;
                    },(duration-1)*1000)



                }
                else{
                    this.player.pauseVideo();
                    this.show_video=true;
                    let duration=video_data.end-video_data.start;
                    if(duration<1){
                        duration=6;
                    }
                    this.player.setVolume(video_data.volume);
                    this.opacity=video_data.opacity/100;
                    this.player.loadVideoById({videoId:video_data.video_id,
                        startSeconds:video_data.start,
                        endSeconds:video_data.end});
                    let self=this;
                    setTimeout(function(){
                        self.player.pauseVideo();
                        self.show_video=false;
                    },(duration-1)*1000)
                }


            }


        },
        mounted:function(){
            document.title="Hihat";


        }

    }
</script>

<style >
    .lift_me_up> * img{
        top:-200px;
    }

    .plastic_cover{
        mix-blend-mode: exclusion !important;
    }

    .blink {
        animation: blink-animation 1s steps(5, start) infinite;
        -webkit-animation: blink-animation 1s steps(5, start) infinite;
    }
    @keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }
    @-webkit-keyframes blink-animation {
        to {
            visibility: hidden;
        }
    }

    .col > * #renderContainerA{
        position: relative !important;
        min-width:500px;
        min-height: 500px;

    }






</style>
